import lotharImg from './images/Lothar_Ueber-Mich.jpeg';
import { 
  GraduationCap, 
  Award, 
  Star, 
  Heart,
  Stethoscope,
  Brain,
  Book,
  Ambulance,
  Handshake,
  Bone,
  Users,
  FileText
} from 'lucide-react';

export default function About() {
  const education = [
    {
      year: "1974",
      title: "Geburtsjahr",
      description: "1974 geboren in Bludenz"
    },
    {
      year: "1992",
      title: "Matura",
      description: "Matura Bundesrealgymnasium Bludenz"
    },
    {
      year: "1992-1999",
      title: "Medizinstudium",
      institution: "Universität Innsbruck, Universität Freiburg (D)",
    },
    {
      year: "2002-2004",
      title: "Ausbildung zum Arzt für Allgemeinmedizin",
      institution: "LKH Bludenz",
    },
    {
      year: "2004-2009",
      title: "Facharztausbildung Innere Medizin",
      institution: "LKH Bludenz",
    },
    {
      year: "2004-2009",
      title: "Notarzt",
      description: "Notarzttätigkeit beim NEF Bludenz und Flugrettungsarzt Gallus 1 in Zürs"
    },
    {
      year: "2010-2011",
      title: "weitere Ausbildungen",
      institution: "Universität Innsbruck",
      description: "Additiv-Facharzt Ausbildung für Rheumatologie an der Universitätsklinik Innsbruck"
    },
    {
      year: "2012-2019",
      title: "Oberarzt",
      institution: "LKH Bludenz",
      description: "Oberarzt an der Abteilung Innere Medizin im LKH Bludenz, bereichsleitender Oberarzt (Rheumatologie) von 2015-2019"
    },
    {
      year: "2013-2019",
      title: "Wahlarzt im LKH Bludenz",
      institution: "LKH Bludenz",
      description: "Wahlarztordination (Innere Medizin und Rheumatologie) im LKH Bludenz"
    },
    {
      year: "2019-2026 bis Jän.",
      title: "Wahlarzt",
      description: "Wahlarztordination Innere Medizin mit Schwerpunkt Rheumatologie in Bludenz"
    },
    {
      year: "seit Feb. 2026",
      title: "Wahlarzt",
      description: "Wahlarztordination Innere Medizin mit Schwerpunkt Rheumatologie in Nüziders"
    }
  ];


  const certificates = [
    {
      title: "Ultraschall Herz (Echokardiographie)",
      icon: Heart
    },
    {
      title: "Ultraschall Bauchorgane (Abdomen)",
      icon: Stethoscope
    },
    {
      title: "Ultraschall hirnversorgende Arterien",
      icon: Brain
    },
    {
      title: "Ultraschall Venen und Arterien",
      icon: Stethoscope
    },
    {
      title: "Ultraschall Pleura und Lunge",
      icon: Stethoscope
    },
    {
      title: "Fortbildungsdiplom",
      icon: Book
    },
    {
      title: "Notarzt",
      icon: Ambulance
    }
  ];

  const consulting = [
    { name: "Österr. Gesellschaft für Innere Medizin", icon: Stethoscope },
    { name: "Österr. Gesellschaft für Rheumatologie und Rehabilitation", icon: Bone },
    { name: "Ärztlicher Berater der Rheumaliga Vorarlberg", icon: Handshake },
    { name: "Ärztlicher Berater der Selbsthilfegruppe Morbus Bechterew Vorarlberg", icon: Users },
    { name: "Zahlreiche Vorträge, Posterpräsentationen und wissenschaftliche Beiträge in diversen Fachzeitschriften als Autor und Koautor", icon: FileText }
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-grid">
          <div className="doctor-profile-card">
            <div className="doctor-header">
              <div className="doctor-avatar">
                <img 
                  src={lotharImg} 
                  alt="Dr. med. Lothar Boso" 
                  className="team-avatar-img" 
                />
              </div>
              <div className="doctor-info">
                <h3>Dr. med. Lothar Boso</h3>
                <p className="doctor-title">
                  Facharzt für Innere Medizin und Rheumatologie
                </p>
              </div>
            </div>
            <div className="timeline-section">
              <div className="timeline-header">
                <div className="timeline-icon education">
                  <GraduationCap color="white" size={24} />
                </div>
                <h3 className="timeline-title">Lebenslauf</h3>
              </div>
              
              <div className="timeline-items">
                {education.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-content">
                      <span className="timeline-year">{item.year}</span>
                      <h4 className="timeline-item-title">{item.title}</h4>
                      <p className="timeline-item-subtitle">{item.institution}</p>
                      <p className="timeline-item-description">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="timeline-section">
              <div className="timeline-header">
                <div className="timeline-icon certificates">
                  <Award color="white" size={24} />
                </div>
                <h3 className="timeline-title">Zertifikate & Qualifikationen</h3>
              </div>
              
              <div className="certificates-grid">
                {certificates.map((cert, index) => {
                  const IconComponent = cert.icon;
                  return (
                    <div key={index} className="certificate-item">
                      <div className="certificate-icon">
                        <IconComponent color="white" size={28} />
                      </div>
                      <div className="certificate-content">
                        <h4>{cert.title}</h4>
                        <p>{cert.institution}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="timeline-section">
              <div className="timeline-header">
                <div className="timeline-icon consulting">
                  <Star color="white" size={24} />
                </div>
                <h3 className="timeline-title">Mitgliedschaften & Beratertätigkeiten</h3>
              </div>
              <div className="consulting-pills">
                {consulting.map((spec, index) => {
                  const IconComponent = spec.icon;
                  return (
                    <div key={index} className="consulting-pill">
                      <div className="consulting-icon">
                        <IconComponent color="white" size={18} />
                      </div>
                      {spec.name}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}